import { render, staticRenderFns } from "./NoProfile.vue?vue&type=template&id=181eef7f&scoped=true&"
import script from "./NoProfile.vue?vue&type=script&lang=js&"
export * from "./NoProfile.vue?vue&type=script&lang=js&"
import style0 from "./NoProfile.vue?vue&type=style&index=0&id=181eef7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181eef7f",
  null
  
)

export default component.exports